import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fd25e99a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-bar van-hairline--bottom" }
const _hoisted_2 = {
  action: "",
  class: "search-form"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "search-comments" }, "注：只能查询1年内的开票申请记录", -1))
const _hoisted_4 = { class: "container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "费用类型:", -1))
const _hoisted_6 = { class: "value" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "开票金额:", -1))
const _hoisted_8 = { class: "value" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "企业名称:", -1))
const _hoisted_10 = { class: "value" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "企业税号:", -1))
const _hoisted_12 = { class: "value" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "注册地址:", -1))
const _hoisted_14 = { class: "value" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "电话号码:", -1))
const _hoisted_16 = { class: "value" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "开户银行:", -1))
const _hoisted_18 = { class: "value" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "银行账号:", -1))
const _hoisted_20 = { class: "value" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "申请时间:", -1))
const _hoisted_22 = { class: "value" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "开票状态:", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "备注:", -1))
const _hoisted_25 = { class: "value" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "取消原因:", -1))
const _hoisted_27 = { class: "value" }
const _hoisted_28 = {
  key: 0,
  class: "download-invoice-container"
}
const _hoisted_29 = { class: "loading" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-text" }, "加载中...", -1))

import { ref } from 'vue'
import { Dialog, Toast } from 'vant'
import { invoiceStateEnum } from './enums'
import { obtainInvoiceApplication } from './service'


export default /*#__PURE__*/_defineComponent({
  __name: 'BillingApplySearch',
  setup(__props) {

const userPhone = ref('')
const onSearch = () => {
  // 校验手机号码格式
  const reg = /^[1][3,4,5,7,8,9][0-9]{9}$/
  if (!userPhone.value.trim()) {
    Toast('请输入申请人手机号')
    return
  } else if (!reg.test(userPhone.value.trim())) {
    Toast('请填写正确的手机号码')
    return
  }
  handleSearch()
}

// 列表相关逻辑
const list = ref<any[]>([])
const isLoading = ref(false)
const finished = ref(false)
const refreshing = ref(false)

const handleSearch = (isRefreshing = false) => {
  finished.value = false
  if (isRefreshing) {
    refreshing.value = true
    setTimeout(() => {
      getList()
    }, 500)
  } else {
    isLoading.value = true
    getList()
  }
}

const getList = () => {
  const data = { userPhone: userPhone.value.trim() }
  obtainInvoiceApplication(data)
    .then((res: any) => {
      if (res.result && res.result.length) {
        list.value = res.result.map((item: any) => {
          const invoiceStateItem = invoiceStateEnum.find((x: any) => x.value === item.invoiceState)
          item.invoiceStateStr = invoiceStateItem ? invoiceStateItem.text : ''
          item.invoiceStateClass = invoiceStateItem ? invoiceStateItem.colorClass : ''
          return item
        })
      } else {
        list.value = []
        Dialog({
          title: '提示',
          message: '未查询到开票申请信息。',
          confirmButtonText: '知道了',
          theme: 'round-button',
          width: '2.6rem',
          confirmButtonColor: '#1989fa'
        })
      }
    })
    .finally(() => {
      isLoading.value = false
      finished.value = true
      refreshing.value = false
    })
}

// 发票下载
const downloadInvoice = async (invoiceFileURL: string) => {
  const segments = new URL(invoiceFileURL).pathname.split('/')
  const baseName = segments[segments.length - 1]
  const fileName = decodeURIComponent(baseName.replace(/\+/g, ' ')) // 替换 '+' 为空格，并解码其他百分比编码的字符

  const el = document.createElement('a') as HTMLAnchorElement
  el.setAttribute('href', invoiceFileURL)
  el.setAttribute('download', fileName)
  el.style.cssText = 'display: none;'
  el.click()
  el.remove()
}

return (_ctx: any,_cache: any) => {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_search = _resolveComponent("van-search")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _component_van_empty = _resolveComponent("van-empty")!
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_van_overlay = _resolveComponent("van-overlay")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_nav_bar, {
      title: "开票申请查询",
      fixed: ""
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("form", _hoisted_2, [
        _createVNode(_component_van_search, {
          modelValue: userPhone.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userPhone).value = $event)),
          "show-action": "",
          shape: "round",
          "input-align": "center",
          label: "",
          placeholder: "请输入申请人手机号",
          onSearch: onSearch
        }, {
          action: _withCtx(() => []),
          _: 1
        }, 8, ["modelValue"]),
        _hoisted_3
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _withDirectives(_createVNode(_component_van_pull_refresh, {
        modelValue: refreshing.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((refreshing).value = $event)),
        onRefresh: _cache[2] || (_cache[2] = ($event: any) => (handleSearch(true)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_list, {
            finished: finished.value,
            "finished-text": "没有更多了"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "list-item"
                }, [
                  _createVNode(_component_van_row, { gutter: "5" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_col, {
                        span: "12",
                        class: "label-value-container"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_5,
                          _createElementVNode("div", _hoisted_6, _toDisplayString(item.typeExpense), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_van_col, {
                        span: "12",
                        class: "label-value-container"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_7,
                          _createElementVNode("div", _hoisted_8, _toDisplayString(item.invoiceAmount), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_van_col, {
                        span: "12",
                        class: "label-value-container"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9,
                          _createElementVNode("div", _hoisted_10, _toDisplayString(item.enterpriseName), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_van_col, {
                        span: "12",
                        class: "label-value-container"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_11,
                          _createElementVNode("div", _hoisted_12, _toDisplayString(item.dutyParagraph), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_van_col, {
                        span: "12",
                        class: "label-value-container"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_13,
                          _createElementVNode("div", _hoisted_14, _toDisplayString(item.registeredAddress), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_van_col, {
                        span: "12",
                        class: "label-value-container"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_15,
                          _createElementVNode("div", _hoisted_16, _toDisplayString(item.phone), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_van_col, {
                        span: "12",
                        class: "label-value-container"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_17,
                          _createElementVNode("div", _hoisted_18, _toDisplayString(item.openingBank), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_van_col, {
                        span: "12",
                        class: "label-value-container"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_19,
                          _createElementVNode("div", _hoisted_20, _toDisplayString(item.bankAccount), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_van_col, {
                        span: "12",
                        class: "label-value-container"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_21,
                          _createElementVNode("div", _hoisted_22, _toDisplayString(item.applicationTime), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_van_col, {
                        span: "12",
                        class: "label-value-container"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_23,
                          _createElementVNode("div", {
                            class: _normalizeClass(`value ${item.invoiceStateClass}`)
                          }, _toDisplayString(item.invoiceStateStr), 3)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_van_col, {
                        span: "24",
                        class: "label-value-container"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_24,
                          _createElementVNode("div", _hoisted_25, _toDisplayString(item.remark), 1)
                        ]),
                        _: 2
                      }, 1024),
                      (item.invoiceState === 2)
                        ? (_openBlock(), _createBlock(_component_van_col, {
                            key: 0,
                            span: "24",
                            class: "label-value-container"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_26,
                              _createElementVNode("div", _hoisted_27, _toDisplayString(item.cancelInvoiceReason), 1)
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024),
                  (item.invoiceFileURL)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _createVNode(_component_van_button, {
                          class: "download-invoice-button",
                          plain: "",
                          hairline: "",
                          round: "",
                          type: "primary",
                          onClick: ($event: any) => (downloadInvoice(item.invoiceFileURL))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 发票下载 ")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _: 1
          }, 8, ["finished"])
        ]),
        _: 1
      }, 8, ["modelValue"]), [
        [_vShow, list.value.length]
      ]),
      _withDirectives(_createVNode(_component_van_empty, { description: "暂无数据" }, null, 512), [
        [_vShow, !list.value.length]
      ])
    ]),
    _createVNode(_component_van_overlay, { show: isLoading.value }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_29, [
          _createVNode(_component_van_loading, { type: "spinner" }),
          _hoisted_30
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})